module.exports = __webpack_public_path__ + "fromBrideToParents-we-g.b2a89ece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-g.jpg
// module id = e4/2
// module chunks = 0